import { Component, OnInit, Input } from '@angular/core';
import { CatalogueService } from 'app/components/catalogue/catalogue.service';
import { ActivatedRoute, Router } from '@angular/router';
import { MenuProductSubMenuService } from 'app/components/menu-product-sub-menu/menu-product-sub-menu.service';
import { RolesService } from 'app/components/roles/roles.service';
import { UtilsService } from 'app/components/utils/utils.service';

@Component({
  selector: 'app-menu-product-sub-menu',
  templateUrl: './menu-product-sub-menu.component.html',
  styleUrls: ['./menu-product-sub-menu.component.css']
})
export class MenuProductSubMenuComponent implements OnInit {

  loader: any = { count: 0 };
  alertType: string = '';
  alertMessage: string = '';

  @Input() active: string = '';
  @Input() buttonTranslation: string = '';
  @Input() buttonLink: string = '';
  @Input() product: object = {};

  catalogueName: string|null = '';
  exhibitorId: string|null = '';

  constructor(public catalogueService: CatalogueService, private activatedRoute: ActivatedRoute, public menuProductSubMenuService: MenuProductSubMenuService,
  private router: Router, public rolesService: RolesService, public utilsService: UtilsService) {
    this.catalogueName = this.activatedRoute.snapshot.paramMap.get('event') || null;
    this.exhibitorId = this.activatedRoute.snapshot.paramMap.get('exhibitorId') || null;
  }

  goTo(url) {
    this.router.navigate([url]);
  }

  backToProducts() {
    let url = this.catalogueName + '/exhibitor-backoffice/exhibitors/' + this.exhibitorId + '/products';
    this.router.navigate([url]);
  }

  ngOnInit() {
  }

}
